import {Analytics, GoogleAnalytics, FacebookPixel, LinkedInInsight, GoogleAnalyticsEventObserver} from '@plaudit/analytics';
const analytics = Analytics.getInstance();
const googleAnalytics = analytics.getTracker(GoogleAnalytics.platformName) as GoogleAnalytics;
const facebookPixel = analytics.getTracker(FacebookPixel.platformName) as FacebookPixel;
const linkedInInsight = analytics.getTracker(LinkedInInsight.platformName) as LinkedInInsight;

if (googleAnalytics !== null) {
	// Goal: Email Link - Click
	googleAnalytics.addHitObserver(
		new GoogleAnalyticsEventObserver(
			() => {
				if (facebookPixel !== null) facebookPixel.trackEventLead({value: 250});
				if (linkedInInsight !== null) linkedInInsight.trackConversion(2188082);
			},
			{
				eventCategory:	(value: string) => value === "Email Link",
				eventAction:	(value: string) => value === "Click"
			}
		)
	);

	// Goal: Telephone Link - Click
	googleAnalytics.addHitObserver(
		new GoogleAnalyticsEventObserver(
			() => {
				if (facebookPixel !== null) facebookPixel.trackEventLead({value: 250});
				if (linkedInInsight !== null) linkedInInsight.trackConversion(2188098);
			},
			{
				eventCategory:	(value: string) => value === "Telephone Link",
				eventAction:	(value: string) => value === "Click"
			}
		)
	);

	// Goal: Contact Us - Success
	googleAnalytics.addHitObserver(
		new GoogleAnalyticsEventObserver(
			() => {
				if (facebookPixel !== null) facebookPixel.trackEventLead({value: 500});
				if (linkedInInsight !== null) linkedInInsight.trackConversion(2188090);
			},
			{
				eventCategory:	(value: string) => value === "Contact Form",
				eventAction:	(value: string) => value.indexOf("Submit") !== -1
			}
		)
	);

	// Goal: Hubspot contact forms
	googleAnalytics.addHitObserver(
		new GoogleAnalyticsEventObserver(
			() => {
				if (facebookPixel !== null) facebookPixel.trackEventLead({value: 500});
				if (linkedInInsight !== null) linkedInInsight.trackConversion(2188090); // Using same conversion as "Contact Us - Success" above.
			},
			{
				eventCategory:	(value: string) => value === "hubspotForm.onFormSubmitted",
				eventAction:	(value: string) => value.indexOf("contactForm") !== -1 // This covers multiple forms under this one action.
			}
		)
	);

	// Goal: Mini Contact Form - Success
	googleAnalytics.addHitObserver(
		new GoogleAnalyticsEventObserver(
			() => {
				if (facebookPixel !== null) facebookPixel.trackEventLead({value: 500});
				if (linkedInInsight !== null) linkedInInsight.trackConversion(2196010);
			},
			{
				eventCategory:	(value: string) => value === "Mini Contact Form",
				eventAction:	(value: string) => value === "Submit"
			}
		)
	);

	// Goal: Gated Content Form - Success
	googleAnalytics.addHitObserver(
		new GoogleAnalyticsEventObserver(
			() => {
				if (facebookPixel !== null) facebookPixel.trackEventLead({value: 250});
				if (linkedInInsight !== null) linkedInInsight.trackConversion(2196002);
			},
			{
				eventCategory:	(value: string) => value === "Gated Content Form",
				eventAction:	(value: string) => value === "Submit"
			}
		)
	);

	// Goal: Newsletter Subscribe - Success
	googleAnalytics.addHitObserver(
		new GoogleAnalyticsEventObserver(
			() => {
				if (facebookPixel !== null) facebookPixel.trackEventLead({value: 100});
				if (linkedInInsight !== null) linkedInInsight.trackConversion(2196018);
			},
			{
				eventCategory:	(value: string) => value === "JSF Action",
				eventAction:	(value: string) => value.indexOf("$subscribe.submit") !== -1
			}
		)
	);
}